// Motion tokens (Astra §1). Response = undamped natural period in seconds, damping = damping ratio.
// Converted to a mass-1 spring: stiffness = (2π / response)², damping = 4π · ratio / response.
import type { Transition } from 'motion/react'

export type SpringToken = { response: number; damping: number }

export const SPRING = {
  press: { response: 0.18, damping: 1 },
  selection: { response: 0.26, damping: 0.9 },
  layout: { response: 0.34, damping: 0.92 },
  navigation: { response: 0.38, damping: 1 },
  sheet: { response: 0.42, damping: 0.92 },
  dragReturn: { response: 0.36, damping: 0.82 },
  cardCommit: { response: 0.3, damping: 0.95 },
  branch: { response: 0.4, damping: 0.9 },
} as const satisfies Record<string, SpringToken>

export type SpringName = keyof typeof SPRING

/** A motion spring for a token; pass the gesture's release velocity so the animation continues from it. */
export function spring(name: SpringName, velocity?: number): Transition {
  const { response, damping } = SPRING[name]
  const k = (2 * Math.PI) / response
  return { type: 'spring', mass: 1, stiffness: k * k, damping: 2 * damping * k, ...(velocity !== undefined ? { velocity } : {}) }
}

/** Fades (Astra §1): 100ms exit, 160ms entry, 120ms replacement. Reduced motion uses these alone. */
export const FADE = {
  exit: { duration: 0.1 },
  enter: { duration: 0.16 },
  replace: { duration: 0.12 },
} as const
